module.exports = __webpack_public_path__ + "img/strike.e35d7f33.svg";